<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormBatchPrintingVerification
      :BatchPrintingVerification="editBatchPrintingVerification"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormBatchPrintingVerification from '../components/FormBatchPrintingVerification.vue';
import formatting from '../mixins/formatting';
import stockItem from './stockItem';

export default {
  components: {
    FormBatchPrintingVerification,
  },
  name: 'EditBatchPrintingVerification',
  module: 'BatchPrintingVerification',
  mixins: [loading, formatting, stockItem],
  data() {
    return {
      /**
      * Get/Set editing BatchPrintingVerification. Default to {}.
      */
      editBatchPrintingVerification: {},
      /**
       * Query Id for BatchPrintingVerification
       */
      batchPrintingVerificationId: this.$route?.query.id,
      /** Get the mode for this view, create or update
      */
      mode: 'add',
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('batchPrintingVerifications', ['batchPrintingVerifications', 'batchPrintingVerification']),
  },
  destroyed() {
    this.$off('stockItem.loaded');
  },
  async mounted() {
    await Promise.all([
      (async () => {
        await this.LOAD_brandingCodes();
      })(),
      (async () => {
        await this.LOAD_canSizes();
      })(),
    ]);
    this.$on('stockItem.loaded', (item) => {
      this.isLoading = true;
      if (item.batchPrintingVerifications?.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.editBatchPrintingVerification = item.batchPrintingVerifications[0];
        this.mode = 'edit';
      } else {
        this.editBatchPrintingVerification.stockItemId = item.id;
        this.editBatchPrintingVerification.farm = item.deliveryNote.farm.name;
        this.editBatchPrintingVerification.date = this.formatDate(item.productionDate);
        this.editBatchPrintingVerification.bestBeforeDate = this.formatDate(dayjs(item.productionDate).add(5, 'year').toISOString());
        this.editBatchPrintingVerification.factoryCode = 'AO';
        this.editBatchPrintingVerification.farmCode = item.deliveryNote.farm.farmCode;
        this.editBatchPrintingVerification.pieces = 'ALL';
        this.editBatchPrintingVerification.productionBatchCode = this.formatProductionCode(item);
      }
      this.$log.info('Prepopulation completed');
      this.$forceUpdate();
    });
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('batchPrintingVerifications', ['LOAD_batchPrintingVerification', 'CREATE_batchPrintingVerification', 'UPDATE_batchPrintingVerification']),
    ...mapActions('brandingCodes', ['LOAD_brandingCodes']),
    ...mapActions('canSizes', ['LOAD_canSizes']),
    /** Method used to save the item
     */
    async save(batchPrintingVerification) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_batchPrintingVerification(batchPrintingVerification);
      } else {
        await this.UPDATE_batchPrintingVerification(batchPrintingVerification);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>

<docs>
# EditBatchPrintingVerification example

'''js
<EditBatchPrintingVerification :BatchPrintingVerification="BatchPrintingVerification" />
'''
</docs>
